var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.99 14.883L21.942 4.023a3.385 3.385 0 00-3.9.01L4.02 14.874a1.564 1.564 0 00-.61 1.785A1.776 1.776 0 005 17.84v16.678a2.225 2.225 0 002.22 2.222h25.556A2.225 2.225 0 0035 34.517V17.84a1.776 1.776 0 001.587-1.18 1.559 1.559 0 00-.598-1.776zm-3.213 20.745H7.221c-.613 0-1.11-.497-1.111-1.11V17.535l13.9-10.788 13.878 10.79v16.981a1.113 1.113 0 01-1.112 1.111zm2.753-19.314a.678.678 0 01-.686.425h-.17L20.634 5.822c-.006-.005-.015-.006-.021-.01-.007-.006-.01-.013-.018-.018a1.133 1.133 0 00-1.231.028L5.324 16.739h-.17a.678.678 0 01-.686-.425.471.471 0 01.22-.552L18.71 4.922a2.239 2.239 0 012.567-.01L35.322 15.77c.189.11.276.335.208.543z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.313 15.813c0-.806-1.055-1.121-1.495-.442-3.227 4.986.953 7.711.953 9.379 0 .747-.608 1.354-1.354 1.354a1.356 1.356 0 01-1.355-1.354v-3.584a.813.813 0 00-1.277-.666A6.508 6.508 0 0013 25.833c0 3.585 2.916 6.5 6.5 6.5s6.5-2.915 6.5-6.5c0-5.765-5.688-6.528-5.688-10.02zM19.5 31.25a5.423 5.423 0 01-5.417-5.417c0-1.589.7-3.309 1.896-4.333v3.25a2.44 2.44 0 002.438 2.438 2.44 2.44 0 002.437-2.438c0-2.204-3.791-4.333-1.537-8.396.725 4.063 5.6 4.58 5.6 9.48A5.423 5.423 0 0119.5 31.25z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.0d47719fd3d7846b04203adc1830d1c7.svg";
export { ForwardRef as ReactComponent };